module.exports = __webpack_public_path__ + "static/media/epic-banner2.b390d4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epic-banner2.png
// module id = 461
// module chunks = 0